import { LinkUtilsDefinition } from '@wix/viewer-service-link-utils/definition'
import type { IModelsAPI } from '@wix/thunderbolt-symbols'
import { createLinkUtils, isUrlCustomized } from '@wix/thunderbolt-commons'
import type { BootstrapData } from '../../types'
import { BOOTSTRAP_DATA, MODELS_API, LINK_UTILS, SERVICES_LOADER } from './moduleNames'
import type { IServices } from './servicesLoader'

const LinkUtils = (bootstrapData: BootstrapData, modelsApi: IModelsAPI, { getService, hasService }: IServices) => {
	const {
		isMobileView,
		platformAPIData: { routersConfigMap },
		platformEnvData: {
			multilingual: multilingualInfo,
			site: { experiments },
			router: { routingInfo },
			location: { metaSiteId, userFileDomainUrl, isPremiumDomain },
		},
	} = bootstrapData
	const isBuilderComponentModel = modelsApi.isBuilderDocument()
	const isServicesInfra = experiments['specs.thunderbolt.servicesInfra'] || isBuilderComponentModel
	if (isServicesInfra && hasService(LinkUtilsDefinition)) {
		return getService(LinkUtilsDefinition)
	}

	return createLinkUtils({
		metaSiteId,
		experiments,
		routingInfo,
		isMobileView,
		isPremiumDomain,
		multilingualInfo,
		userFileDomainUrl,
		routersConfig: routersConfigMap,
		getRoleForCompId: modelsApi.getRoleForCompId,
		popupPages: bootstrapData.platformEnvData.popups?.popupPages,
		getCompIdByWixCodeNickname: modelsApi.getCompIdByWixCodeNickname,
		getIsUrlCustomized: (url: string) => {
			const { platformEnvData } = bootstrapData
			const urlMappings = platformEnvData?.customUrlMapper?.urlMappings
			const baseUrl = bootstrapData.location?.externalBaseUrl

			return isUrlCustomized(url, baseUrl, urlMappings)
		},
	})
}

export default {
	factory: LinkUtils,
	deps: [BOOTSTRAP_DATA, MODELS_API, SERVICES_LOADER],
	name: LINK_UTILS,
}
